import { createReducer, on } from '@ngrx/store'
import {
  loginFailure,
  loginSuccess,
  logout,
  setUser,
} from './authentication.actions'
import type { User } from './auth.model'

export type AuthenticationState = {
  isLoggedIn: boolean
  user: User | null
  // The OAuth2 access token, kept separate from the user model — the user is claims, the token is transport.
  token: string
  error: any | null
}

const initialState: AuthenticationState = {
  isLoggedIn: false,
  user: null,
  token: '',
  error: null,
}

export const authenticationReducer = createReducer(
  initialState,
  on(loginSuccess, (state, { user, token }) => ({
    ...state,
    isLoggedIn: true,
    user,
    token,
    error: null,
  })),
  on(setUser, (state, { user }) => ({
    ...state,
    user,
  })),
  on(loginFailure, (state, { error }) => ({
    ...state,
    error,
    isLoggedIn: false,
  })),
  on(logout, (state) => ({
    ...state,
    user: null,
    token: '',
    isLoggedIn: false,
    error: null,
  }))
)
